var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"common-back",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"zmdi zmdi-chevron-left"}),_vm._v(_vm._s(_vm.$tc('common.comeback')))])}
var staticRenderFns = []

export { render, staticRenderFns }